/* eslint no-lone-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint no-unused-vars: 0 */
/* eslint array-callback-return: 0 */
/* eslint jsx-a11y/anchor-is-valid: 0 */
import React, {Component} from 'react';
import Menu from 'semantic-ui-react/dist/es/collections/Menu';
import Button from 'semantic-ui-react/dist/es/elements/Button';
import Icon from 'semantic-ui-react/dist/es/elements/Icon';
import Confirm from 'semantic-ui-react/dist/es/addons/Confirm';
import {Form} from 'formsy-semantic-ui-react';
import Header from  'semantic-ui-react/dist/es/elements/Header';
import Modal from  'semantic-ui-react/dist/es/modules/Modal';
import './App.css';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Moment from "react-moment"
import global from "./global"
import {BidListEditRecord} from "./BidListEdit"
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import {toast}  from 'react-toastify';



export class BidList extends Component {

    componentWillMount = () => {
        this.setState({
            access_token: this.props.access_token,
            isLoggedIn: this.props.isloggedIn,
            data: [],
            pages: null,
            loading: false,
            currentpage: 1,
            randomkey: Math.random(),
            showmodal: false,
            searchkey: "",
            pageSize: 20,
            sorted: "bids.contract_start desc",
            current_user: JSON.parse(sessionStorage.getItem("current_user"))


        });

    }

    handleclose = () => {
        if (this.isDirty) {
            this.setState({confirmOpen: true})
        } else {
            this.setState({showmodal: false})
            this.updateTable()
        }

    }

    loadRecord = (recid) => {
        var parms = {
            id: recid
        }
        var component = this
        global.getFetch("bids/read", parms, this.state.access_token).then(function (resp) {
            component.setState({
                editRecord: resp,
                columns: resp.columns,
                departments: resp.departments,
                showmodal: true,
                recid: recid,
                editname: resp.rec.name

            });
        })
    }

    fetchData = (state, instance) => {
        var obj = JSON.parse(sessionStorage.getItem("current_user"));
        this.setState({loading: true});

        var srts = ""
        state.sorted.map(function (i) {
            srts += (srts === "" ? "" : ",") + (!i.id.includes(".") ? "contracts." : "") + i.id + (i.desc ? " desc" : " asc")
            return srts
        })
        if (srts === "") {
            srts = "bids.contract_start desc"
        }
        var component = this;
        var parms = {
            pageSize: state.pageSize,
            page: state.page + 1,
            sorted: srts,
            search: this.state.searchkey

        }


        global.getFetch("bids", parms, this.state.access_token).then(function (resp) {
            component.setState({
                data: resp.rows,
                pages: resp.pages,
                loading: false,
                currentpage: state.page + 1,
                parms: parms,
                sorted: srts,
                pageSize: state.pageSize
            });
        })
    }

    updateTable = () => {
        var comp = this;
        var parms = {
            pageSize: this.state.pageSize,
            page: this.state.currentpage,
            sorted: this.state.sorted,
            search: this.state.searchkey
        }

        global.getFetch("bids", parms, this.state.access_token).then(function (resp) {
            comp.setState({
                data: resp.rows,
                pages: resp.pages,
                loading: false,
            });
        })

    }

    newRecord = () => {
        var comp = this
        var parms = []
        global.getFetch("bids/new", parms, this.state.access_token).then(function (resp) {
            comp.setState({
                editRecord: resp,
                showmodal: true,
                recid: null,
                editname: "New Bid",

            });
        })

    }

    showBid = (rowInfo) => {
        this.isDirty = false
        this.loadRecord(rowInfo.row.id)

    }

    render() {
        const {columns, editRecord, departments, access_token, data, pages, loading, randomkey, recid, editname, pageSize, cats} = this.state
        var current_user=JSON.parse(sessionStorage.getItem("current_user"))
        return (
            <div>
                <Menu style={{border: 'none'}}>
                    <Menu.Item style={{border: 'none'}}>
                        {current_user.can_create_boilerplates ?
                            <Button size="tiny" icon='write' label="New Bid" onClick={this.newRecord}/>
                            : ""}
                        <Button size="tiny" icon='refresh' label="Refresh Page" onClick={this.updateTable} />
                    </Menu.Item>
                    <Menu.Menu position='right' style={{border: 'none'}}>
                        <Menu.Item style={{border: 'none'}}>
                            <Form ref="searchform" >
                                <Form.Input name="search" action={{icon: 'search'}} placeholder='Search...'
                                            />
                            </Form>
                        </Menu.Item>
                    </Menu.Menu>

                </Menu>
                <Modal
                    open={this.state.showmodal}
                    size='large' closeIcon
                    closeOnRootNodeClick={true}
                    onClose={this.handleclose}


                >

                    <Header icon='browser' content={editname}/>
                    <Modal.Content>
                        <Confirm
                            open={this.state.confirmOpen}
                            onCancel={this.handleCancel}
                            onConfirm={this.handleConfirm}
                            content="You have unsaved changes. Are you sure?"
                            style={{fontSize: "1.2rem"}}

                        />
                        <BidListEditRecord access_token={access_token} data={editRecord} ></BidListEditRecord>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button size="tiny" color='green' onClick={this.handleclose} inverted>
                            <Icon name='checkmark'/> Close
                        </Button>
                    </Modal.Actions>
                </Modal>

                <ReactTable
                    key={randomkey}

                    getTdProps={(state, rowInfo, column, instance) => {
                        return {
                            onDoubleClick: (e, handleOriginal) => {
                                // IMPORTANT! React-Table uses onClick internally to trigger
                                // events like expanding SubComponents and pivots.
                                // By default a custom 'onClick' handler will override this functionality.
                                // If you want to fire the original onClick handler, call the
                                // 'handleOriginal' function.
                                if (column.Header==="D") {
                                    this.DeleteTemplate(rowInfo.row.id)
                                }
                                if (column.Header==="E") {
                                    this.showBid(rowInfo)

                                }
                            }
                        }
                    }}

                    columns={[
                        {
                            Header: "E",
                            Cell: row => (
                                <div class='iconedit'>
                                    <Icon name='edit'/>
                                    <span class="tooltiptext">Double Click to Edit</span>
                                </div>),
                            width: 30
                        },

                        // {
                        //     Header: "P",
                        //     Cell: row => (
                        //         <div>
                        //                 <Icon name='file pdf outline'/>
                        //             </div>),
                        //     width: 30
                        // },
                        current_user.can_delete_boilerplates ?

                            {
                            Header: "D",
                            Cell: row => (
                                <div class='iconedit'>
                                            <Icon name='delete'/>
                                            <span class="tooltiptext">Double Click to Delete</span>
                                </div>),
                            width: 30
                        } :
                            {
                                Header: "",
                                width: 1
                            }
                        ,
                        {
                            Header: "Id",
                            accessor: "id",
                            width: 60
                        },
                        {
                            Header: "RFP/Q#",
                            accessor: "bid_no"
                        },
                        {
                            Header: "Name",
                            accessor: "name"
                        },
                        {
                            Header: "Department",
                            accessor: "department"
                        },
                        {
                            Header: "Announcement Date",
                            accessor: "announcement_date",
                            width: 100,
                            Cell: row => (
                                <div>
                                    {row.value === null ? " " :
                                        <Moment format="MM/DD/YYYY">
                                            {row.value}
                                        </Moment>
                                    }
                                </div>
                            )
                        },
                        {
                            Header: "Opening Date",
                            accessor: "opening_date",
                            width: 100,
                            Cell: row => (
                                <div>
                                    {row.value === null ? " " :
                                        <Moment format="MM/DD/YYYY">
                                            {row.value}
                                        </Moment>
                                    }
                                </div>
                            )
                        },
                        {
                            Header: "Status",
                            accessor: "bid_status"
                        },
                    ]}
                    showPaginationTop
                    manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                    data={data}
                    pages={pages} // Display the total number of pages
                    loading={loading} // Display the loading overlay when we need it
                    onFetchData={this.fetchData} // Request new data when things change
                    defaultPageSize={pageSize}
                    className="-striped -highlight"
                />
            </div>
        )
    }
}